module.exports = __webpack_public_path__ + "img/vannkraft_med_paavirkningsgrad.73592647.jpg";